export default __webpack_public_path__ + "static/media/phoneCall.42e4ada2.svg";